import React from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";

export default function HelpPage() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="container introduce-page !mt-[70px]">
      <HeaderTop title={i18next.t("support_center")} />
      <div className="flex flex-col gap-4 bg-black p-2">
        <Link className="bg-[#1c1c1e] rounded" to="/help/detail/1">
          <img
            src="https://api.demo92.apptestlive.com/assets/images/how_are_they_different.png"
            alt="banner"
            height="100"
            width="100"
            className="w-full"
          />
          <div className="flex flex-col gap-2 p-4">
            <h2 className="text-xl text-white">How to make a deposit?</h2>
            <span className="text-sm text-[#888] whitespace-nowrap text-ellipsis overflow-hidden">
              Looking for a guide on how to deposit funds? We hear you! Here is
              a detailed operation process so that you can easily make a deposit
              by transferring cryptocurrency from your wallet or depositing fiat
              currency to your account.
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
}
